import React, { useState } from 'react'
import { Badge, Card, Pagination, Table } from 'react-bootstrap'
import './Lotes.css'
import ModalVistaPreviaPDF from 'Components/ModalVistaPreviaPDF'
import { useErrorModal } from 'Context/ErrorModalContext'
import { useBlockUI } from 'Context/BlockUIContext'
import { useApi } from 'ApiHooks'
import { Lote } from 'Interfaces/LoteBusqueda'

export interface LotesCardDesktopProps {
    title: string
    variant: string
    data: any[]
    totalPaginas: number
    paginaActual: number
    obtenerLotesPaginado: (pagina: number) => Promise<void>
}

const LotesCardDesktop = ({ title, variant, data, totalPaginas, paginaActual, obtenerLotesPaginado }: LotesCardDesktopProps) => {

    const api = useApi()
    const { showBlock, hideBlock } = useBlockUI()
    const { showError } = useErrorModal()

    const [showModalPDF, setShowModalPDF] = useState<boolean>(false)
    const [base64Data, setBase64Data] = useState<string | null>(null)
    const [nroLotePDF, setNroLotePDF] = useState<number | null>(null)
    const [fechaLote, setFechaLote] = useState<string>('')
    const [tipoEnvioLote, setTipoEnvioLote] = useState<string>('')

    const impresionLotes = async (nrosLotes: [number]) => {
        showBlock("Generando impresión de lotes...")
        try {
            const response = await api.generarImpresionLotes(nrosLotes)
            setBase64Data(response?.formularioStringBase64)
            setShowModalPDF(true)
            hideBlock()
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            hideBlock()
        }
    }

    return (
        <>
            <Card className="h-100 shadow-sm border-0">
                <Card.Header className={`bg-${variant} text-white d-flex justify-content-between align-items-center`}>
                    {title}
                    <Badge variant="light" color="dark">
                        {data.length}
                    </Badge>
                </Card.Header>


                <Card.Body className="p-0">
                    {data.length === 0 ? (
                        <div className="p-4 text-center text-muted">
                            <i className="bi bi-inbox fs-2 d-block mb-2"></i>
                            No hay registros para mostrar
                        </div>
                    ) : (
                        <div className="table-responsive lotes-table">
                            <Table hover size="sm" className="mb-0">
                                <thead className="thead-light">
                                    <tr>
                                        <th>ID</th>
                                        <th>Lote</th>
                                        <th>Fecha</th>
                                        <th>Correo</th>
                                        <th>Domicilio de Recepción</th>
                                        <th>Localidad de Recepción</th>
                                        <th>Estado</th>
                                        <th>Observaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((lote: Lote, index: number) => (
                                        <tr key={index} onClick={() => {
                                            setNroLotePDF(Number(lote?.generadorId))
                                            setTipoEnvioLote(lote?.correo)
                                            setFechaLote(lote?.fechaEnvio)
                                            impresionLotes([Number(lote?.generadorId)])
                                        }} style={{ cursor: 'pointer' }}>

                                            <td>
                                                <p className="font-weight-bold">
                                                    {lote.generadorId}
                                                </p>
                                            </td>
                                            <td>
                                                <p className="font-weight-bold">
                                                    {lote.nroImpresionLote}
                                                </p>
                                            </td>


                                            <td>{lote.fechaEnvio}</td>
                                            <td>
                                                <Badge variant="secondary">{lote?.correo === "" ? 'BANK' : lote?.correo}</Badge>
                                            </td>
                                            <td>{lote.domicilioRecepcion}</td>
                                            <td>{lote.localidadRecepcion}</td>
                                            <td>{lote?.estadoDescripcion}</td>
                                            <td>{lote.observaciones}</td>
                                        </tr>
                                    ))}
                                </tbody>

                            </Table>

                        </div>

                    )}
                    {totalPaginas > 1 && (
                        <Pagination className="justify-content-center mt-3">
                            <Pagination.First
                                disabled={paginaActual === 1}
                                onClick={() => obtenerLotesPaginado(1)}
                            />

                            <Pagination.Prev
                                disabled={paginaActual === 1}
                                onClick={() => obtenerLotesPaginado(paginaActual - 1)}
                            />

                            {[...Array(totalPaginas)].map((_, i) => (
                                <Pagination.Item
                                    key={i + 1}
                                    active={paginaActual === i + 1}
                                    onClick={() => obtenerLotesPaginado(i + 1)}
                                >
                                    {i + 1}
                                </Pagination.Item>
                            ))}

                            <Pagination.Next
                                disabled={paginaActual === totalPaginas}
                                onClick={() => obtenerLotesPaginado(paginaActual + 1)}
                            />

                            <Pagination.Last
                                disabled={paginaActual === totalPaginas}
                                onClick={() => obtenerLotesPaginado(totalPaginas)}
                            />
                        </Pagination>
                    )}
                </Card.Body>
            </Card>
            <ModalVistaPreviaPDF
                showModalVistaArchivo={showModalPDF}
                handleCloseModalVisualizarArchivo={() => {
                    setShowModalPDF(false)
                    setBase64Data(null)
                    obtenerLotesPaginado(1)
                }}
                base64Archivo={base64Data!}
                nombreArchivo={tipoEnvioLote === 'ANDREANI' ? `BANK_Pedido_guia_Andreani_${fechaLote}.pdf` : `BANK_Pedido_guia_${nroLotePDF}.pdf`}
                nroLotePDF={nroLotePDF!}
            />
        </>
    )
}

export default LotesCardDesktop